import { useProfile } from '../components/profile/ProfileProvider'
import { ProjectFragment, ProjectVisibility } from '../generated/graphql'

type Authorization = {
  canEditProject: (project: ProjectFragment | null) => boolean
}

export function useAuthorization(): Authorization {
  const user = useProfile()

  const groupIds = user.groups?.map((group) => group.id) ?? []

  const canEditProject = (project: ProjectFragment | null) => {
    if (!project) {
      return false
    }

    if (user.isAdmin) {
      return true
    }

    if (project.visibility === ProjectVisibility.AllUsers) {
      return true
    }

    if (project.visibility === ProjectVisibility.Self) {
      return project.owner.id === user.id
    }

    if (project.visibility === ProjectVisibility.UserGroup) {
      return Boolean(
        project.userGroup && groupIds.includes(project.userGroup.id),
      )
    }

    return false
  }

  return {
    canEditProject,
  }
}
